import Dialog from "components/Dialog";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import React, {useEffect, useState} from "react";
import Tr from "translations/Translations";
import Loading from "components/Loading";
import {Checkbox as MuiCheckbox, Checkbox} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import OfferEvaluationService from "../../../../../../../../services/OfferEvaluationService";
import SimpleTable from "../../../../../../../../components/complex/simpleTable/SimpleTable";
import GridBlock from "../../../../../../../../components/GridBlock";

const useStyle = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(2)
    },
    checkbox: {
        padding: "0"
    },
    cursor: {
        cursor: "pointer"
    },
    cells: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    orderColumn: theme.components.table.ipColumn,
    checkboxColumn: {
        width: theme.spacing()
    }
}))

function OfferEvaluationOptionDialog (
    {
        demandId,
        open = true,
        onClose = () => {}
    }) {

    const classes = useStyle();
    const [positions, setPositions] = useState(null);
    const [selectedPositionsMap, setSelectedPositionsMap] = useState(new Map());
    const [working, setWorking] = useState(false);
    const isAllChecked = !!positions && selectedPositionsMap.size === positions.filter(p => !p.readOnly || !!p.showOfferValuesWithOption).length;

    useEffect(() => {
        OfferEvaluationService.getPositionsWithOption(demandId).then(resp => {
            setPositions(resp.list);
            const newMap = new Map();
            resp.list.forEach(e => {
                if (!!e.showOfferValuesWithOption)
                    newMap.set(e.identity, e.identity);
            })
            setSelectedPositionsMap(newMap);
        });
    }, [demandId])

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onClose, 'outlined'));
        buttons.push(createButton(Tr('confirm'), () => handleSubmit(), undefined, working));
        return buttons;
    }

    const handleSubmit = () => {
        setWorking(true);
        OfferEvaluationService.setPositionsWithOption(demandId, Array.from(selectedPositionsMap.keys())).then(r => onClose());
    }

    const toggleCheckbox = (e, x) => {
        e.stopPropagation();
        const newMap = new Map(selectedPositionsMap);
        if (newMap.has(x.identity)) {
            newMap.delete(x.identity);
        } else {
            newMap.set(x.identity, x.identity);
        }
        setSelectedPositionsMap(newMap);
    }

    const handleHeadCheckboxChange = (e) => {
        e.stopPropagation();
        const newMap = new Map();
        if (selectedPositionsMap.size === positions.filter(p => !p.readOnly || !!p.showOfferValuesWithOption).length) {
            positions.forEach(e => {
                if (!!e.readOnly && !!e.showOfferValuesWithOption)
                    newMap.set(e.identity, e.identity);
            })
        } else {
            positions.forEach(e => {
                if (!e.readOnly || !!e.showOfferValuesWithOption)
                    newMap.set(e.identity, e.identity);
            })
        }
        setSelectedPositionsMap(newMap);
    }

    return (
        <Dialog
            open={open}
            title={Tr('positions_with_option_dialog')}
            onClose={onClose}
            dialogActions={
                <MultiButton
                    buttons={getButtons()}
                />}
            >
            {!positions && <Loading />}
            {!!positions && <GridBlock
                className={classes.root}
                column
            >
                <SimpleTable
                    headers={[
                        <MuiCheckbox
                            color='primary'
                            className={classes.checkbox}
                            onChange={e => handleHeadCheckboxChange(e)}
                            checked={isAllChecked}
                            disabled={!positions || !positions.some(p => !p.readOnly)}
                        />,
                        Tr('part_number'),
                        Tr('part_name')
                    ]}
                    items={positions.map(x => {
                        return [
                            <Checkbox
                                className={classes.checkbox}
                                checked={selectedPositionsMap.has(x.identity)}
                                tabIndex={-1}
                                disableRipple
                                onClick={(e) => toggleCheckbox(e, x)}
                                disabled={x.readOnly}
                            />,
                            <label className={classes.cursor}>{x.ordinalNumber}</label>,
                            <label className={classes.cursor}>{x.name}</label>,
                        ]
                    })}
                    cellClassName={classes.cells}
                    columnClasses={[
                        classes.checkboxColumn,
                        classes.orderColumn
                    ]}
                />
            </GridBlock>}
        </Dialog>
    )
}

export default OfferEvaluationOptionDialog;